// frontend/apps/demo/piwa-portfolio/src/ui/utils/cn.ts
import clsx, { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}